import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Button } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { TopBar } from '@component/top_bar.component';
import { useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import { ViewBookingController } from '../view_booking.controller';
import { Title } from '@component/title.component';
import styled from 'styled-components';
import { Illustration } from '@component/illustration/mod';
import { ButtonArrange } from '@component/button_arrange.component';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		max-width: 100%;
	`,
};

export function ScreenError() {
	const controller = useResolveController(ViewBookingController);
	const analytics = useAnalyticContext();

	function handleRestart() {
		analytics.trackEvent('Clicked start over');
		controller.goToReceptionHome();

		// TODO: Remove when angular is gone!
		if (
			(window as typeof window & { __TEMP__overrideNavigation: Record<string, unknown> | undefined })['__TEMP__overrideNavigation'] !=
			null
		) {
			window.location.reload();
		}
	}

	useEffect(
		function whenMounted() {
			analytics.service.trackPageView({
				customTitle: 'Booking: Error',
			});
		},
		[analytics],
	);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1} align='center' justify='center'>
				<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
					<elements.illustration type='error' />
					<Title
						title={withTranslation('View.Booking.ErrorInterrupted.Title')}
						titleSize='small'
						description={withTranslation('View.Booking.ErrorInterrupted.Body')}
					/>
				</elements.container>
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={handleRestart}>
							{withTranslation('View.Booking.ErrorInterrupted.Button')}
						</Button>
					</ButtonArrange>
				</Flex>
			</Flex>
		</>
	);
}
